import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DropDownList } from '../../../../models/DropDownList.model';
import { CompaniesService } from '../../../../services/companies.service';
import { CommonHelper } from '../../../../shared/helpers/CommonHelper';
import { Company } from "../../../../models/Company.model";
import { ExcellenceCenter } from "../../../../models/ExcellenceCenter.model";
import { Toast, ToastsManager } from "ng2-toastr";
import { ExcellenceCentersService } from "../../../../services/excellenceCenters.service";
import { AwsService } from "../../../../services/aws.service";
import * as _ from 'lodash';
import * as moment from 'moment'
import { ErrorHandlerProvider } from "../../../../shared/providers/errorHandler.provider";
import { ActivatedRoute, Router } from "@angular/router";
import { VendorInventoryModel } from '../../../../models/vendor-inventory/VendorInventory.model';
import { VendorInventoryService } from '../../../../services/vendorInventory.service';
import { DropdownSettingsFactory } from '../../../../shared/factories/dropdown/dropdown-settings.factory';
import { DropdownItemFactory } from '../../../../shared/factories/dropdown/dropdown-item.factory';
import { GroupReadjustmentQuoeficient } from '../../../../shared/enums/readjustmentQuoeficient.enum';
import { VendorInventoryType } from '../../../../shared/enums/VendorInventoryType';
import { ConsultantService } from '../../../../services/consultant.service';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-vendor-inventory-edit',
  templateUrl: './vendor-inventory.component-edit.html',
  styleUrls: ['./vendor-inventory.component-edit.scss'],
})
export class VendorInventoryEditComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;

  loading = false;
  datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
  dateMask = [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

  vendorInventory = new VendorInventoryModel();
  selectedFiles: FileList;

  vendors: Company[] = new Array<Company>();
  dropDownVendor = {
    list: [], options: null, selected: []
  };
  dropDownListVendors: DropDownList[] = new Array<DropDownList>();
  selectedVendorsItems: DropDownList[] = new Array<DropDownList>();
  dropDownVendorsSettings = {};

  excellenceCenters: Array<ExcellenceCenter> = [];
  allCenters: Array<ExcellenceCenter> = [];
  dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();
  selectedExcellenceCentersItems: DropDownList[] = new Array<DropDownList>();
  dropDownExcellenceCentersSettings = {};

  types: VendorInventoryType[];
  dropDownListTypes: DropDownList[] = new Array<DropDownList>();
  selectedTypesItems: DropDownList[] = new Array<DropDownList>();
  dropDownTypesSettings = {};
  readjustmentQuoeficient: GroupReadjustmentQuoeficient[];
  consultants: any;
  fileList;
  downloadUrl = '';

  constructor(
    public commonHelper: CommonHelper,
    private companiesService: CompaniesService,
    private consultantService: ConsultantService,
    private toastr: ToastsManager,
    private dropDownSettingFactory: DropdownSettingsFactory,
    private dropDownItemFactory: DropdownItemFactory,
    private excellenceCentersService: ExcellenceCentersService,
    private awsService: AwsService,
    private errorHandler: ErrorHandlerProvider,
    private vendorInventoryService: VendorInventoryService,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
  ) { }

  async ngOnInit(): Promise<void> {
    this.loading = true;

    const id = this.route.snapshot.params['id'];
    if (id) {
        const inventory = await this.vendorInventoryService.getById(id);
        this.vendorInventory.populate(inventory);
    } else {
        this.router.navigateByUrl('/vendor-inventory');
        return;
    }

    this.readjustmentQuoeficient = this.commonHelper.getAllReadjustmentQuoeficientGroups();
    this.types = this.commonHelper.getAllVendorInventoryTypes();

    this.consultants = await this.consultantService.listAll(false);
    this.consultants = this.consultants
      .filter(consultantFilter => consultantFilter.sapCardCode &&
        consultantFilter.contract &&
        consultantFilter.contract.kind == 1)
      .map(consultantMap => {
        return {
          _id: consultantMap._id,
          name: consultantMap.contract.companyName,
          cnpj: consultantMap.contract.cnpj,
          sapCardCode: consultantMap.sapCardCode
        }
      });
    let consultantDropdownAux = this.dropDownItemFactory.build({ source: this.consultants });
    consultantDropdownAux = consultantDropdownAux.map(consultant => ({ ...consultant, type: 'Fornecedor - Consultor PJ' }));

    this.vendors = await this.companiesService.listVendors();
    let vendorsDropdownAux = this.dropDownItemFactory.build({ source: this.vendors });
    vendorsDropdownAux = vendorsDropdownAux.map(vendor => ({ ...vendor, type: 'Fornecedor - Empresa' }));

    this.dropDownVendor.options = this.dropDownSettingFactory.build({ text: 'Fornecedores', singleSelection: true, enableCheckAll: false, groupBy: 'type' });
    this.dropDownVendor.list = vendorsDropdownAux.concat(consultantDropdownAux);

    const allCenters = await this.excellenceCentersService.getAll();
    this.excellenceCenters = allCenters.filter(ec => Number(ec.type) == 1);

    this.formatDatesForView();
    this.selectCurrentVendor();

    await this.getS3Files();
    if(this.fileList.length > 0) {
        this.download(this.fileList[0].Key);
    }
    this.loading = false;
  }

  selectCurrentVendor(){
    if (this.vendorInventory.vendor && this.vendorInventory.vendor._id){
      this.dropDownVendor.selected[0] = {
        id: this.vendorInventory.vendor._id,
        itemName: this.vendorInventory.vendor.name
      };
    }
  }

  async getS3Files(): Promise<void>{
    this.fileList = await this.awsService.getFiles(`vendor-inventory/${this.vendorInventory._id}`);
  };

  async deleteFile(name: string): Promise<void>{
    try {
        const fileName = name.split("/")[1];
        this.toastr.warning(`Realizando a exclusão do arquivo ${fileName}...`, 'Exclusão');
        await this.awsService.deleteFile(name);
        this.toastr.success(`Arquivo ${fileName} excluído com sucesso!`);
        await this.getS3Files();
    } catch (error) {
        this.errorHandler.interceptError(error, "Inventário")
    }
  }

  async download(name: string): Promise<void> {
    this.downloadUrl = await this.awsService.download(name);
  }

  verifyDate(date: string, field: string, nested?: string): boolean {
    if (field.startsWith('endDate') && this.vendorInventory.endDate.undefinedPeriod) {
      this.vendorInventory.endDate.date = '';
      return;
    }

    if (field.startsWith('readjustmentDate') && !this.vendorInventory.readjustmentDate.notApplicable) {
      this.vendorInventory.readjustmentDate.date = '';
      return;
    }

    let errorMessage = [];
    if (!(new RegExp(this.datePattern).test(date))) {
      if (field.startsWith('endDate') || field.startsWith('readjustmentDate') || field.startsWith('noticeDate')) {
        this.vendorInventory[field][nested] = "";
        errorMessage.push(`Digite um padrão de data válida para o campo, ${this.transcriptDateFields(field, nested)}`);
        this.toastr.warning(`${errorMessage.join('<br/>')}`, "Data inválida!", { enableHTML: true });
        return true;
      }
      this.vendorInventory[field] = "";
      errorMessage.push(`Digite um padrão de data válida para o campo, ${this.transcriptDateFields(field)}`);
      this.toastr.warning(`${errorMessage.join('<br/>')}`, "Data inválida!", { enableHTML: true });
      return true;
    }

    const isValidDate = moment(date, 'DD/MM/YYYY');
    if (!isValidDate.isValid()) {
      if (field.startsWith('endDate') || field.startsWith('readjustmentDate') || field.startsWith('noticeDate')) {
        this.vendorInventory[field][nested] = "";
        errorMessage.push(`Valor inserido é inválido para o campo, ${this.transcriptDateFields(field, nested)}`);
        this.toastr.warning(`${errorMessage.join('<br/>')}`, "Data inválida!", { enableHTML: true });
        return true;
      }
      this.vendorInventory[field] = "";
      errorMessage.push(`Valor inserido é inválido para o campo, ${this.transcriptDateFields(field)}`);
      this.toastr.warning(`${errorMessage.join('<br/>')}`, "Data inválida!", { enableHTML: true });
      return true;
    }
    return false;
  }

  validateContractDateRange(dateStart: string, endDate: string): Promise<Toast> {
    if (dateStart && endDate)
      if (new Date(this.convertDateStringToISO(dateStart)).getTime() >= new Date(this.convertDateStringToISO(endDate)).getTime()) {
        this.vendorInventory.endDate.date = '';
        return this.toastr.warning("A data final do contrato deve ser maior que a data de início do contrato.");
      }
  }

  validateNotApplicableDates(dateStart: string, endDate: string, date: string, fieldToCompare: string, fieldNameDisplay: string): void {
    if (!this.vendorInventory[fieldToCompare].notApplicable) {
      this.vendorInventory[fieldToCompare].date = '';
      return;
    };

    if (dateStart && endDate && date) {
      if (
        new Date(this.convertDateStringToISO(dateStart)).getTime() <= new Date(this.convertDateStringToISO(date)).getTime() &&
        new Date(this.convertDateStringToISO(endDate)).getTime() >= new Date(this.convertDateStringToISO(date)).getTime()
      ) {
        const insertedDate = moment(date, "DD/MM/YYYY");
        if (insertedDate.isBefore()) {
            this.vendorInventory[fieldToCompare].date = '';
            this.toastr.warning(`A data de ${fieldNameDisplay} não pode ser retroativa.`, 'Data Inválida');
            return;
        }
       } else {
        this.vendorInventory[fieldToCompare].date = '';
        this.toastr.warning(`A data de ${fieldNameDisplay} deve estar entre o início e fim do contrato.`);
        return;
      }
    } else {
      this.vendorInventory[fieldToCompare].date = '';
      this.toastr.warning("Verifique os campos de datas e insira corretamente.", "Data inválida!");
      return;
    }
  }

  convertDateStringToISO(date: string): string {
    return `${date.substring(3, 5)}/${date.substring(0, 2)}/${date.substring(6, 11)}`;
  }

  selectFile(event: any): void {
    if (event.target.files.length > 10) {
      this.toastr.warning(
        'Não é possível fazer upload com mais de 10 arquivos. Selecione os arquivos novamente.',
        'Atenção!'
      );
      return;
    };
    this.selectedFiles = event.target.files as FileList;
  }

  async upload(id: string): Promise<void> {
    try {
        let length = this.selectedFiles.length;
        const maxAllowedFiles = 10;
        const filesSum = this.fileList.length + this.selectedFiles.length;
        if (filesSum > maxAllowedFiles) {
            this.toastr.warning(
                `Não é possível fazer upload com mais de ${maxAllowedFiles} arquivos.`, "Atenção!"
            );
            return;
        }
        for(let i=0; i<length; i++){
            const file = this.selectedFiles.item(i);
            await this.awsService.uploadfile(file,`vendor-inventory/${id}`);
        }
        await this.getS3Files();
        this.selectedFiles = null;
    } catch (error) {
        this.errorHandler.interceptError(error, "Inventário");
    }
  }

  isTypeFieldInvalid(): boolean {
    if (!this.vendorInventory.type) {
      this.toastr.warning("Selecione o tipo.", "Atenção!");
      return true;
    }

    return false;
  }

  isQuoficientInvalid(): boolean {
    if (!this.vendorInventory.readjustmentIndex) {
      this.toastr.warning('Escolha um índice de reajuste.', 'Atenção!');
      return true;
    }

    return false;
  }

  areDateFieldsInvalid(): boolean {
    if (!this.vendorInventory.startDate) {
      this.vendorInventory.startDate = '';
      this.toastr.warning("Preencha o campo de data de início do contrato.", "Atenção!");
      return true;
    }

    if (this.verifyDate(this.vendorInventory.startDate, 'startDate')) {
      this.toastr.warning("Preencha o campo de data de início do contrato corretamente.", "Atenção!");
      return true;
    }

    if (!this.vendorInventory.endDate.date) {
      this.vendorInventory.endDate.date = '';
      this.toastr.warning("Preencha o campo de data de vencimento do contrato.", "Atenção!");
      return true;
    }

    if (this.verifyDate(this.vendorInventory.endDate.date, 'endDate')) {
      this.toastr.warning("Preencha o campo de data de vencimento do contrato corretamente.", "Atenção!");
      return true;
    }

    return false;
  }

  transcriptDateFields(field: string, nested?: string): string {
    const dateFields = {
      startDate: 'Data de início',
      endDate: {
        date: 'Data de vencimento'
      },
      readjustmentDate: {
        date: 'Data de reajuste'
      },
      noticeDate: {
        date: 'Data de aviso prévio sobre vigência'
      }
    }
    return nested ? dateFields[field][nested] : dateFields[field];
  }

  isVendorInvalid(): boolean {
    if (this.dropDownVendor && (!this.dropDownVendor.selected || this.dropDownVendor.selected.length == 0)) {
      this.toastr.warning(
        'Escolha um fornecedor',
        'Atenção!'
      );
      return true;
    }
    return false;
  }

  areOptionalDatesInvalid(): boolean {
    if (this.vendorInventory.readjustmentDate.notApplicable && !this.vendorInventory.readjustmentDate.date) {
      this.toastr.warning("Verifique se o campo de data de reajuste está preenchido.", "Atenção!");
      return true;
    }

    if (this.vendorInventory.noticeDate.notApplicable && !this.vendorInventory.noticeDate.date) {
      this.toastr.warning("Verifique se o campo de data de aviso prévio está preenchido.", "Atenção!");
      return true;
    }

    return false;
  }

  prepareModel(): void{
    if (this.vendorInventory.excellenceCenter && this.vendorInventory.excellenceCenter._id && this.vendorInventory.excellenceCenter._id !== "undefined") {
      this.vendorInventory.excellenceCenter = this.excellenceCenters.find((center) => center._id == this.vendorInventory.excellenceCenter._id);
    }

    this.vendorInventory.vendor = {
      _id: this.dropDownVendor.selected[0].id,
      name: this.dropDownVendor.selected[0].itemName
    } as Company;

    this.formatDatesInModel();
  }

  async onSave(): Promise<void> {
    if (this.isVendorInvalid() ||
      this.isTypeFieldInvalid() ||
      this.areDateFieldsInvalid() ||
      this.isQuoficientInvalid() ||
      this.areOptionalDatesInvalid()) {
      return;
    }
    this.prepareModel();
    this.loading = true;
    try {
      const response = await this.vendorInventoryService.edit(this.vendorInventory);
      if (response && response._id) {
        this.loading = false;
        this.toastr.success('Inventário de fornecedor editado com sucesso!');
        this.router.navigate(['/companies/vendor-inventory']);
      }
    } catch (error) {
      this.toastr.error('Erro ao editar inventário de fornecedor');
      this.errorHandler.interceptError(error, 'Inventário de Fornecedores');
    }finally{
      this.loading = false;
    }
  }

  formatDatesForView(){
    this.checkDateToggles();
    if (this.vendorInventory.startDate) {
      this.vendorInventory.startDate = moment(this.vendorInventory.startDate).format("DD/MM/YYYY");
    }

    if (this.vendorInventory.endDate && this.vendorInventory.endDate.date) {
      this.vendorInventory.endDate.date = moment(this.vendorInventory.endDate.date).format("DD/MM/YYYY");
    }

    if (this.vendorInventory.readjustmentDate && this.vendorInventory.readjustmentDate.date) {
      this.vendorInventory.readjustmentDate.date = moment(this.vendorInventory.readjustmentDate.date).format("DD/MM/YYYY");
    }

    if (this.vendorInventory.noticeDate && this.vendorInventory.noticeDate.date) {
      this.vendorInventory.noticeDate.date = moment(this.vendorInventory.noticeDate.date).format("DD/MM/YYYY");
    }
  }

  formatDatesInModel() {
    this.checkDateToggles();
    if (this.vendorInventory.startDate) {
      this.vendorInventory.startDate = moment(this.vendorInventory.startDate, "DD/MM/YYYY").add(4, 'hours').toString();
    }

    if (this.vendorInventory.endDate && this.vendorInventory.endDate.date) {
      this.vendorInventory.endDate.date = moment(this.vendorInventory.endDate.date, "DD/MM/YYYY").add(4, 'hours').toString();
    }

    if (this.vendorInventory.readjustmentDate && this.vendorInventory.readjustmentDate.date) {
      this.vendorInventory.readjustmentDate.date = moment(this.vendorInventory.readjustmentDate.date, "DD/MM/YYYY").add(4, 'hours').toString();
    }

    if (this.vendorInventory.noticeDate && this.vendorInventory.noticeDate.date) {
      this.vendorInventory.noticeDate.date = moment(this.vendorInventory.noticeDate.date, "DD/MM/YYYY").add(4, 'hours').toString();
    }
  }

  checkDateToggles() {
    if (!this.vendorInventory.readjustmentNotificationDays.notApplicable) {
      this.vendorInventory.readjustmentNotificationDays.days = 0;
    }

    if (!this.vendorInventory.noticeNotificationDays.notApplicable) {
      this.vendorInventory.noticeNotificationDays.days = 0;
    }
  }

  changeNotificationDaysToggleAndInput(dateFieldName: string, notificationDaysFieldName: string) {
    if (this.vendorInventory[dateFieldName].notApplicable) {
        this.vendorInventory[dateFieldName].date = '';
        this.vendorInventory[notificationDaysFieldName].notApplicable = false;
    }
    this.cd.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/vendor-inventory/vendor-inventory-edit/vendor-inventory.component-edit.ts